import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import VirtualFenceCircleAlert from './virtual-fence-circle-alert';
import VirtualFenceCircleAlertUpdate from './virtual-fence-circle-alert-update';
import VirtualFenceCircleAlertDeleteDialog from './virtual-fence-circle-alert-delete-dialog';
import { VirtualFenceAlert } from 'app/modules/virtual-fence-alert-map';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={VirtualFenceCircleAlertUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={VirtualFenceCircleAlertUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={VirtualFenceAlert} />
      <ErrorBoundaryRoute path={match.url} component={VirtualFenceCircleAlert} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={VirtualFenceCircleAlertDeleteDialog} />
  </>
);

export default Routes;
